import { getScopedItem, STORAGE_KEYS } from "../components/common/Helper";
import APIConstants from "./APIConstants";
import APIService from "./APIService";
import DebugService from "./DebugService";

/**
 * @description User Invoice Api Service
 */
const UserInvoiceApiService = {

  getData: async () => {
    try {
      let url = APIConstants.ENDPOINT_USER_INVOICE

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (parseToJson['userId']) {
          url += `/${parseToJson['userId']}`
        }
      }

      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`User Invoice Api Service: Error Caught while fetching data`, err)
    }
  },
}

export default UserInvoiceApiService;
